module.exports = __webpack_public_path__ + "img/correct.0feaa48a.svg";